import * as React from "react"
import debounce from "lodash/debounce"
import { Spin } from "antd"
import { Select } from "components-design-system"

const DebouncePaginatedSelect = ({
  onChange,
  value,
  getNextDocumentsAPI,
  filterAllDocumentsAPI,
  mode,
  useGetInitialData,
  ...moreProps
}) => {
  const { data: allDocuments = [], isSuccess: isDocumentFetchSuccessful } = useGetInitialData()
  const [next, setNext] = React.useState()
  const [fetching, setFetching] = React.useState(false)
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    if (isDocumentFetchSuccessful) {
      setOptions(allDocuments.results)
      setNext(allDocuments?.next)
    }
  }, [isDocumentFetchSuccessful])

  const fetchRef = React.useRef(0)
  var debounceTimeout = 300

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setFetching(true)

      filterAllDocumentsAPI(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return
        }
        setOptions(newOptions.data.results)
        setNext(newOptions.data.next)
        setFetching(false)
      })
    }
    return debounce(loadOptions, debounceTimeout)
  }, [filterAllDocumentsAPI, debounceTimeout])

  const handleFetchingMoreData = (e) => {
    const target = e?.target || e?.currentTarget
    if (!target) return

    const { scrollTop, scrollHeight, clientHeight } = target

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      if (next) {
        getNextDocumentsAPI(next).then((res) => {
          setOptions([...options, ...res.data.results])
          setNext(res.data.next)
        })
      }
    }
  }
  return (
    <Select
      onSearch={debounceFetcher}
      options={options}
      onPopupScroll={handleFetchingMoreData}
      mode={mode}
      notFoundContent={fetching ? <Spin size="small" /> : "No results found"}
      value={value}
      onChange={onChange}
      {...moreProps}
    />
  )
}

export default DebouncePaginatedSelect
